import NaptimeResource from './NaptimeResource';

class ProfileConsents extends NaptimeResource {
  static RESOURCE_NAME = 'profileConsents.v1';
}

export default ProfileConsents;
